import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { Field } from 'kts-scaffold-framework/utils/doc';
const css = require('./index.scss');
import { Table, Card, Icon, Tooltip } from 'antd';

/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

  constructor(props: IProps) {
    super(props, ModulesAction);
  }

  componentWillMount() {
    ModulesAction.groupInfo(this.props.match.params.id);
  }
  creatTip = (record) => {
    let warnArray = [];
    if (record.matchState) {
      return (
        <Tooltip title='匹配成功'>
          <Icon className={css['action']} type="check-circle" style={{ color: `rgba(34,172,56,1)`, fontSize: 14 }} />
        </Tooltip>);
    } else {
      if (record.realCheckState === 'FAILED') {
        warnArray.push(<div key="6">{record.realCheckMessage}</div>);
      }
      if (record.duplicateState === 'FAILED') {
        warnArray.push(<div key="7">重复录入</div>);
      }
      if (record.standardState === 'FAILED') {
        warnArray.push(<div key="8">{record.standardMessage}</div>);
      }
      if (record.receivedState !== true) {
        warnArray.push(<div key="9">发票未收到</div>);
      }
      if (record.shouldState !== true) {
        warnArray.push(<div key="5">非本组应收发票</div>);
      }
      const warnMessage = <div>{warnArray}</div>;
      return (
        <Tooltip title={warnMessage}>
          <Icon className={css['action']} type="close-circle" style={{ color: `rgba(230,0,18,1)`, fontSize: 14 }} />
        </Tooltip>
      );
    }
  }
  render() {
    const data = this.dealData(this.modulesState.detailInfoList);
    const columns = this.tableColumn(this.modulesState.groupInfo.createType);
    return (
      <Card title="发票列表" bordered={false}>
        <Table
          className={`kts-app-ant-table`}
          columns={columns}
          dataSource={data}
          bordered={true}
          pagination={false}
        />
      </Card>
    );
  }

  private InvoiceSure = props => {
    return (props.sure ?
      <span><Icon className={css['action']} type="gou" style={{ color: `rgba(34,172,56,1)`, fontSize: '13px' }} /></span> :
      <span><Icon className={css['action']} type="cha" style={{ color: 'rgba(230,0,18,1)', fontSize: '17px' }} /></span>);
  }

  private dealData = list => {
    let dealWidthData = [];
    list.forEach(ele => {
      if (ele.shouldState && ele.receivedState) {
        dealWidthData.push(ele);
      } else {
        dealWidthData.unshift(ele);
      }
    });
    return dealWidthData;
  }

  private tableColumn = (createType: number): any => {
    return [{
      title: '发票代码',
      dataIndex: 'invoiceCode',
      key: 'name',
      render: (text, record) => {
        if (createType === 1 && !record.matchState) {
          return <span className={css['font-red']}>{text}</span>;
        } else {
          return <span>{text}</span>;
        }
      }
    },
    {
      title: '发票号码',
      dataIndex: 'invoiceNumber',
      key: 'number',
      render: (text, record) => {
        if (createType === 1 && !record.matchState) {
          return <span className={css['font-red']}>{text}</span>;
        } else {
          return <span>{text}</span>;
        }
      }
    },
    {
      title: '开票日期',
      dataIndex: 'invoiceDate',
      render: (text) => Field.formatDate(text)
    },
    {
      title: '无税金额',
      dataIndex: 'amountWithOutTax',
      render: (text) => Field.formatMoney(text, 2)
    },
    {
      title: '校验码',
      dataIndex: 'invoiceParityCode',
    },
    {
      title: '匹配状态',
      dataIndex: 'matchState',
      className: createType ? 'text-center' : 'hide',
      render: (text, record) => {
        return (
          <span>
            {
              this.creatTip(record)
            }
          </span>
        );
      }
    },
    {
      title: '应收',
      dataIndex: 'shouldState',
      key: 'shouldState',
      className: createType ? '' : 'hide',
      render: (text, record) => (
        <this.InvoiceSure sure={record.shouldState} />
      ),
    },
    {
      title: '已收',
      dataIndex: 'receivedState',
      key: 'receivedState',
      className: createType ? '' : 'hide',
      render: (text, record) => (
        <this.InvoiceSure sure={record.receivedState} />
      ),
    },
    {
      title: '操作',
      key: 'action',
      render: (text, record) => (
        <span>
          {
            record.receivedState &&
            <a href="javascript:;" onClick={() => ModulesAction.deleteDetailInfoList(record.loggingId, record.shouldState)}>移除</a>
          }
        </span>
      ),
    }
    ];

  }
}


// WEBPACK FOOTER //
// ./src/display/apps/InvoiceInput/Group/UI.Table.tsx